import * as Types from './types';

export function setActiveTab(newState: Types.Tabs): Types.InformationPageActions {
  return {
    type: Types.SET_ACTIVE_TAB,
    payload: newState,
  };
}
